module.exports = __webpack_public_path__ + "1acd08d40d83bf27fe23d53494081b8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-0.png
// module id = 2149
// module chunks = 0